import { useStaticQuery, useStaticMutation } from '../../../helpers/useStaticData';
import { getAdvertising } from '../../../helpers/data';

export const useGetAdvertisingQuery = () => useStaticQuery(() => getAdvertising());

export const useAddMessageMutation = () => useStaticMutation();
